// App.tsx
import PropTypes from "prop-types";
import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Authmiddleware from "./routes/route";
import VerticalLayout from "./components/VerticalLayout";
import NonAuthLayout from "./components/NonAuthLayout";

import "./assets/scss/theme.scss";
import "react-toastify/dist/ReactToastify.css";

import getStorageData from "./Utils/getStorageData";
import { useSubAdminRoutes } from "./routes/SubAdmin"; // ✅ import hook
import SendOtp from "./pages/Authentication/SendOtp";
import VerifyOTP from "./pages/Authentication/VerifyOtp";
import { SocketProvider } from "./Utils/socket";
import AppUpdateNotifier from "./components/Common/AppUpdateNotifier";

const App = () => {
  const Layout = VerticalLayout;
  const userType = getStorageData().userType;
  const isAuthorized = localStorage.getItem("Authorization");

  // ✅ use the hook here
  const subAdminRoutes = useSubAdminRoutes();

  const authProtectedRoutes = userType === 3 ? subAdminRoutes : [];
  const publicRoutes = [
    { path: "/", component: <SendOtp /> },
    { path: "/verify-otp", component: <VerifyOTP /> },
  ];

  return (
    <SocketProvider>
      <React.Fragment>
        <AppUpdateNotifier />

        <Routes>
          {!isAuthorized &&
            publicRoutes.map((route: any, idx: any) => (
              <Route
                path={route.path}
                element={<NonAuthLayout>{route.component}</NonAuthLayout>}
                key={idx}
              />
            ))}

          {isAuthorized &&
            authProtectedRoutes.map((route: any, idx: any) => (
              <Route
                path={route.path}
                element={
                  <Authmiddleware>
                    <Layout>{route.component}</Layout>
                  </Authmiddleware>
                }
                key={idx}
              />
            ))}

          <Route
            path="*"
            element={
              isAuthorized ? (
                <Navigate
                  to={userType === 3 ? "/control-panel" : "/premises"}
                />
              ) : (
                <Navigate to="/" />
              )
            }
          />
        </Routes>
      </React.Fragment>
    </SocketProvider>
  );
};

App.propTypes = {
  layout: PropTypes.any,
};

export default App;
